'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSides = exports.containsPoint = exports.isOverlapping = exports.addPadding = exports.translate = exports.scale = exports.getCentre = exports.getRect = undefined;

var _fp = require('lodash/fp');

var _geometry = require('./jointjs/geometry');

var _geometry2 = _interopRequireDefault(_geometry);

var _point = require('./point');

var pointLib = _interopRequireWildcard(_point);

var _line = require('./line');

var lineLib = _interopRequireWildcard(_line);

var _geometryUtils = require('./geometryUtils');

var geometryUtils = _interopRequireWildcard(_geometryUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Formalises it, but does nothing
var getRect = exports.getRect = function getRect(_ref) {
    var x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height;
    return { x: x, y: y, width: width, height: height };
};

// Geometry
// Lib
var getCentre = exports.getCentre = function getCentre(rect) {
    return pointLib.getPoint(rect.x + rect.width / 2, rect.y + rect.height / 2);
};

var scale = exports.scale = geometryUtils.scale;
var translate = exports.translate = geometryUtils.translate;

var addPadding = exports.addPadding = (0, _fp.curry)(function (padding, rect) {
    return {
        x: rect.x - padding,
        y: rect.y - padding,
        width: rect.width + 2 * padding,
        height: rect.height + 2 * padding
    };
});

var isOverlapping = exports.isOverlapping = (0, _fp.curry)(function (rect1, rect2) {
    if (!rect1 || !rect2) return false;

    var jjsRect1 = _geometry2.default.rect(rect1);
    var jjsRect2 = _geometry2.default.rect(rect2);

    return !!jjsRect1.intersect(jjsRect2);
});

var containsPoint = exports.containsPoint = (0, _fp.curry)(function (rect, point) {
    if (!rect || !point) return false;

    return point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height;
});

var getTopLine = function getTopLine(rect) {
    return lineLib.getLine(pointLib.getPoint(rect.x, rect.y), pointLib.getPoint(rect.x + rect.width, rect.y));
};

var getRightLine = function getRightLine(rect) {
    return lineLib.getLine(pointLib.getPoint(rect.x + rect.width, rect.y), pointLib.getPoint(rect.x + rect.width, rect.y + rect.height));
};

var getBottomLine = function getBottomLine(rect) {
    return lineLib.getLine(pointLib.getPoint(rect.x, rect.y + rect.height), pointLib.getPoint(rect.x + rect.width, rect.y + rect.height));
};

var getLeftLine = function getLeftLine(rect) {
    return lineLib.getLine(pointLib.getPoint(rect.x, rect.y), pointLib.getPoint(rect.x, rect.y + rect.height));
};

var getSides = exports.getSides = function getSides(rect, side) {
    return {
        top: getTopLine(rect),
        right: getRightLine(rect),
        bottom: getBottomLine(rect),
        left: getLeftLine(rect)
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/rect.js
// module id = 208
// module chunks = 0